import React from 'react';
import PropTypes from 'prop-types';

export const List = ({ width, height, ...props }) => (
  <svg
    data-icon='list'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M9 19v-2h12v2H9Zm0-6v-2h12v2H9Zm0-6V5h12v2H9ZM5 20c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 18c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 16c.55 0 1.02.196 1.412.587C6.804 16.98 7 17.45 7 18s-.196 1.02-.588 1.413A1.926 1.926 0 0 1 5 20Zm0-6c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 0 1 3 12c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 10c.55 0 1.02.196 1.412.588.392.391.588.862.588 1.412 0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 5 14Zm0-6c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 0 1 3 6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 4c.55 0 1.02.196 1.412.588C6.804 4.979 7 5.45 7 6c0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 5 8Z'
    />
  </svg>
);

List.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

List.defaultProps = {
  width: 24,
  height: 24,
};
